// import { Button, Form, Grid, Input, Select } from 'antd';
import { Button, Form, Grid, Input } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AmenitiesFilterFormField, AmenitiesFilterFormValues } from './types';

const { useBreakpoint } = Grid;

type AmenitiesFilterFormProps = {
  formId: string;
  handleFilter: (values: AmenitiesFilterFormValues) => void;
  initialValues: AmenitiesFilterFormValues;
  closeModal?: () => void;
};

export const AmenitiesFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
}: AmenitiesFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<AmenitiesFilterFormValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();

  const onReset = () => {
    form.resetFields();
  };

  const handleOnFinish = (values: AmenitiesFilterFormValues) => {
    handleFilter(values);
    closeModal?.();
  };

  // const chargeableOptions = [
  //   {
  //     label: t('common.yes'),
  //     value: true,
  //   },
  //   {
  //     label: t('common.no'),
  //     value: false,
  //   },
  // ];

  return (
    <Form<AmenitiesFilterFormValues>
      id={formId}
      name={formId}
      form={form}
      layout='vertical'
      onFinish={handleOnFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper>
        <StandardItemsWrapper>
          <Form.Item<AmenitiesFilterFormValues>
            label={t('amenities.formFields.amenityName.label')}
            name={AmenitiesFilterFormField.AmenityName}
          >
            <Input
              placeholder={t('amenities.formFields.amenityName.placeholder')}
            />
          </Form.Item>
          {/* <Form.Item<AmenitiesFilterFormValues>
            label={t('amenities.formFields.chargeable.label')}
            name={AmenitiesFilterFormField.Chargeable}
          >
            <Select
              options={chargeableOptions}
              className='filter'
              placeholder={t('amenities.formFields.chargeable.placeholder')}
            />
          </Form.Item> */}
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>

      {screens.lg && (
        <ContentFilters.ButtonsWrapper>
          <Button type='primary' htmlType='submit'>
            {t('bookings.buttons.filter', { count: 1 })}
          </Button>
          <Button onClick={onReset}>{t('bookings.buttons.reset')}</Button>
        </ContentFilters.ButtonsWrapper>
      )}
    </Form>
  );
};
